// --------------------------------------------------------------------------
// faintFilterToggle.js
// --------------------------------------------------------------------------
//
// --------------------------------------------------------------------------

RN.faintFilterToggle = function() {
    'use strict';
    function init() {
      byBehaviour('faint-filter-toggle').on('click', toggle);
    }

    function toggle(){
      var $this = $(this);
      var form = $($this.attr('data-form'));
      var isOpen = $this.closest('.faint-overlay').toggleClass('faint-overlay--closed').hasClass('faint-overlay--closed');
      form.slideToggle(isOpen);
      return false;
    }

    return {
        init: init
    };

}();
